import { Component } from "@angular/core";
import { GuideService } from "./services/guide.service";
import { IGuide } from "./models/guide";
import { Router, ActivatedRoute } from "@angular/router";
import { ModuleItem } from "./models/module-item";
import { _1AComponent } from "./components/group1/1A.component";
import { _1BComponent } from "./components/group1/1B.component";
import { _1CComponent } from "./components/group1/1C.component";
import { _2AComponent } from "./components/group2/2A.component";
import { _2BComponent } from "./components/group2/2B.component";
import { _3AComponent } from "./components/group3/3A.component";
import { _3BComponent } from "./components/group3/3B.component";
import { _3CComponent } from "./components/group3/3C.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ConfirmModalComponent } from "./components/confirm-modal.component";

@Component({
  templateUrl: "./guide.component.html",
  styleUrls: ["./guide.component.css"],
  providers: [GuideService]
})

export class GuideComponent {

  fullScreen: boolean = false;
  totalSections: number = 0;
  completedSection: number = 0;
  percentCompletedSection: number = 0;  

  loaded: boolean = false;
  guide: IGuide;

  moduleGroupId: string;
  sectionId: string;
  moduleId: string;
  activityId: string;
  complete: string;

  activeComponent: any;

  modules: Array<ModuleItem>;

  confirmModalRef: BsModalRef;

  constructor(private _route: ActivatedRoute,
    private _router: Router,
    private _guideService: GuideService, private bsModalService: BsModalService) {

    //fixes issue when params change, but route doesn't
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {

    this.moduleGroupId = this._route.snapshot.paramMap.get("moduleGroupId");
    this.sectionId = this._route.snapshot.paramMap.get("sectionId");
    this.moduleId = this._route.snapshot.paramMap.get("moduleId");
    this.activityId = this._route.snapshot.paramMap.get("activityId");
    this.complete = this._route.snapshot.paramMap.get("complete");

    //console.log("moduleGroupId", this.moduleGroupId);
    //console.log("sectionId", this.sectionId);
    //console.log("moduleId", this.moduleId);
    //console.log("complete", this.complete);

    this.loadModules();
    this.loadGuide();
  }

  resetGuide() {

    this.confirmModalRef = this.bsModalService.show(ConfirmModalComponent);

    this.confirmModalRef.content.onClose.subscribe((resp: boolean) => {

      if (resp) {

        this._guideService.resetGuide();

        setTimeout(() => {
          let currentUrl = this._router.url;
          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate([currentUrl]);
          });
          this.loadGuide();
        }, 1000);
      }

    });    
  }

  loadModules() {
    this.modules = [];

    this.modules.push(new ModuleItem(_1AComponent, "1", "A", {}));
    this.modules.push(new ModuleItem(_1BComponent, "1", "B", {}));
    this.modules.push(new ModuleItem(_1CComponent, "1", "C", {}));
    this.modules.push(new ModuleItem(_2AComponent, "2", "A", {}));
    this.modules.push(new ModuleItem(_2BComponent, "2", "B", {}));
    this.modules.push(new ModuleItem(_3AComponent, "3", "A", {}));
    this.modules.push(new ModuleItem(_3BComponent, "3", "B", {}));
    this.modules.push(new ModuleItem(_3CComponent, "3", "C", {}));
  }

  loadGuide() {
    this._guideService.get().subscribe(res => {

      //console.log("Guide",res);

      this.guide = res;
      this.loaded = true;
      this.loadModule(this.moduleGroupId, this.sectionId);

      for (var group of this.guide.groups) {

        this.totalSections += group.sections.length;

        for (var i = 0; i < group.sections.length; i++) {

          group.sections[i].alpha
          group.sections[i].number 

          /*var modules = group.modules.filter(f => f.alpha == group.sections[i].alpha && f.number == group.sections[i].number);*/
          var modules = group.modules.filter(f => f.alpha == group.sections[i].alpha);

          if (modules.length == modules.filter(f => f.complete).length) {
            group.sections[i].complete = true;
            this.completedSection += 1;
          }
        }
      }

      this.percentCompletedSection = (this.completedSection / this.totalSections) * 100;      
    });
  }


  loadModule(groupId: string, sectionId: string) {
    //console.log("loadModule", groupId, sectionId);

    const activeModule = this.modules.filter(f => f.groupId == groupId && f.sectionId == sectionId);
    this.activeComponent = null;

    //console.log("Active Module", activeModule);

    if (activeModule != null && activeModule.length > 0) {

      this.activeComponent = activeModule[0].component;
      //console.log("Load Module", this.activeComponent);
    }
  }

  toggleFullScreen() {
    this.fullScreen = !this.fullScreen;
  }
}
